import { useEffect } from 'react';
import EcoNavPage from 'eco-design/sections/eco-nav-page';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
// import { useProduct, useProductStore } from '../../../ProductProvider';
import { useProductStore } from '../../../../ProductProvider';
export default function Comp() {
    const { t } = useLang('theProductV2.NavPage');
    const { pageStatus } = useProductStore();

    const item1Href = pageStatus === 'statusC' ? '#rapid-mag-Screen4-V2' : '#rapid-mag-F';
    const itemsA = [
        {
            title: t('item1'),
            href: item1Href,
        },
        {
            title: t('item2'),
            href: '#rapid-mag-Screen6-V2',
        },
    ];

    useEffect(() => {
        if (typeof window === 'undefined') return;
        
        // 获取导航元素
        const navElement = document.getElementById('rapid-mag-NavPage-V2');
        if (!navElement) return;

        const callback = () => {
            // 检查是否应该显示导航栏 (基于第一个导航项)
            const screen1 = document.querySelector(item1Href);
            if (screen1) {
                const screen1Top = screen1.getBoundingClientRect().top;
                if (screen1Top <= 80) {
                    navElement.classList.add('active');
                } else {
                    // 只有当滚动回顶部时才移除active类
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    if (scrollTop === 0) {
                        navElement.classList.remove('active');
                    }
                }
            }
            
            // 查找当前应该激活的导航项
            let activeIndex = -1;
            let closestIndex = -1;
            let closestDistance = Infinity;
            
            // 检查每个导航项对应的元素位置
            itemsA.forEach((item, index) => {
                const targetElement = document.querySelector(item.href);
                if (targetElement) {
                    const rect = targetElement.getBoundingClientRect();
                    
                    // 判断元素是否在视口中
                    const isInViewport = rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2;
                    
                    // 如果元素在视口中间区域，则标记为激活
                    if (isInViewport) {
                        activeIndex = index;
                    }
                    
                    // 计算元素中心点到视口中心的距离
                    const elementCenter = (rect.top + rect.bottom) / 2;
                    const viewportCenter = window.innerHeight / 2;
                    const distance = Math.abs(elementCenter - viewportCenter);
                    
                    // 更新最近的元素
                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestIndex = index;
                    }
                }
            });
            
            // 如果没有元素在视口中间区域，则使用最近的元素
            if (activeIndex === -1 && closestIndex !== -1) {
                activeIndex = closestIndex;
            }
            
            // 更新导航项的激活状态
            itemsA.forEach((_, index) => {
                const navItem = navElement.querySelector(`.eco-nav-page-item:nth-child(${index + 1})`);
                if (navItem) {
                    if (index === activeIndex) {
                        navItem.classList.add('eco-nav-page-item-active');
                    } else {
                        navItem.classList.remove('eco-nav-page-item-active');
                    }
                }
            });
        };
        
        // 初始化时执行一次检查
        callback();
        
        window.addEventListener('scroll', callback);
        return () => {
            window.removeEventListener('scroll', callback);
        };
    }, [item1Href, itemsA]);
    
    return (
        <section
            className={`${styles.comp}  GtmModuleData-section`}
            id="rapid-mag-NavPage-V2"
            data-section-id={'rapid-mag-NavPage-V2'}
            data-section-title="rapid-mag-NavPage-v2"
        >
            <EcoNavPage items={itemsA} openGTM />
        </section>
    );
}